import {VehicleType} from '../../gql/customer/graphql.ts';
import {List} from '../list/list.tsx';
import {VehicleListItem} from './vehicle_list_item.tsx';
import {FlexRow} from '../utility/flex_row.tsx';
import {FlexColumn} from '../utility/flex_column.tsx';
import {Alignment} from '../../enums/alignment.ts';
import {Icon} from '../icon/icon.tsx';
import {VehicleBrandModel} from './vehicle_brand_model.tsx';
import {HideElement} from '../utility/hide_element_wrapper.tsx';
import {Identifier} from '../identifier/identifier.tsx';
import {ShowElement} from '../utility/show_element_wrapper.tsx';
import {CardSelect} from '../card/card_select.tsx';
import {getLicensePlate} from '../../support/get_data.ts';
import {__} from '../../support/lang/translations.ts';
import {Card} from '../card/card.tsx';
import {IdentifierSize} from '../../support/enums/identifier_size.ts';
import {brandLogo} from '../../support/brand_logo.ts';
interface OwnProps {
    vehicles?: (VehicleType | null)[] | null;
    selectedVehicleId: number;
    onChange: (vehicleId: number) => void;
}

export function VehicleSelect({vehicles, onChange, selectedVehicleId}: OwnProps) {
    const onVehicleSelect = (id?: number | null) => {
        if (id !== null && id !== undefined) {
            onChange(id);
        }
    };

    let toggle = null;
    if (vehicles) {
        const vehicle = vehicles.find((vehicle) => vehicle?.id === selectedVehicleId);
        vehicles = vehicles.filter((vehicle) => vehicle?.id !== selectedVehicleId);
        const brandUrl = brandLogo(vehicle?.brand);
        toggle = (
            <FlexRow>
                <FlexColumn alignment={Alignment.Start}>
                    <FlexRow>
                        <Icon src={brandUrl} />
                        <VehicleBrandModel
                            style={{margin: '0 auto 0 1rem'}}
                            brand={vehicle?.brand ? vehicle?.brand : (__('vehicles.defaults.unknown') as string)}
                            model={vehicle?.model ? vehicle?.model : (__('vehicles.defaults.unknown') as string)}
                            alignment={Alignment.Start}
                        />
                    </FlexRow>
                </FlexColumn>
                <FlexColumn alignment={Alignment.End}>
                    <HideElement size={'sm'}>
                        <Identifier
                            style={{margin: '0 1rem'}}
                            identifier={getLicensePlate(vehicle)}
                            size={IdentifierSize.Large}
                        />
                    </HideElement>
                    <ShowElement size={'sm'}>
                        <Identifier
                            style={{margin: '0 1rem'}}
                            identifier={getLicensePlate(vehicle)}
                            size={IdentifierSize.Small}
                        />
                    </ShowElement>
                </FlexColumn>
            </FlexRow>
        );
    }

    if (vehicles && vehicles?.length > 0) {
        return (
            <CardSelect toggle={toggle}>
                <List>
                    {vehicles?.map((vehicle, key) => (
                        <VehicleListItem vehicle={vehicle} key={key} onClick={() => onVehicleSelect(vehicle?.id)} />
                    ))}
                </List>
            </CardSelect>
        );
    } else {
        return <Card>{toggle}</Card>;
    }
}
